import { createContext } from 'react';
import { CallContextValues } from './types';

const CallContext = createContext<CallContextValues>({
    init: () => {},
    destroy: () => {},
    isNotificationEnabled: false,
    setActivePhoneNumber: () => {},
    makeCall: () => {},
    answer: () => {},
    closeAnswer: () => {},
    join: () => {},
    reject: () => {},
    hangup: () => {},
    disconnect: () => {},
    getVideoInterpreter: () => {},
    closeRating: () => {},
    connected: false,
    isConnecting: false,
    isIncomingCall: false,
    isOutgoingCall: false,
    region: null,
    requestId: null,
    requestType: 'P2P',
    roomName: null,
    toPhoneNumber: null,
    twilioRoomId: null,
    twilioVideoToken: null,
    twilioVoiceToken: null,
    callDuration: 0,
    calleeName: null,
    calleeNumber: null,
    callerName: null,
    callerNumber: null,
    interpreterId: null,
    interpreterNRPCDNumber: null,
    interpreterName: null,
    providerName: null,
    requestStatus: null,
    ringTimeout: 15,
    vco: false,
    isJoining: false,
    isRatingAvailable: false,
    ratingDetail: null,
    deviceId: null,
    userId: null,
    phoneNumber: null,
    error: null,
    clearError: () => {},
    refreshedAccessToken: null,
    setVco: () => {},
    position: null,
    isVideoMailDialogVisible: false,
    requestIdForVedioMail: '',
    messageForVideoMail: '',
    handleMessageForVideoMail: () => {},
    handleRequestIdForVedioMail: () => {},
    showVideoMailDialog: () => {},
    hideVideoMailDialog: () => {},
    setDialogFlagTrue: () => {},
    setDialogFlagFalse: () => {},
    videoMailDialogFlagVisible: false,
    isVideoMailAlertPopupVisible: false,
    showVideoMailAlertDialog: () => {},
    hideVideoMailAlerDialog: () => {},
    isAlertPopupOnCancelVisible: false,
    showAlertDialogOnCancel: () => {},
    hideAlertDialogOnCancel: () => {},
    isCameraTurnedOffBeforeCall: false,
    twilioRoom: null,
    storeTwilioRoom: () => {},
});

export default CallContext;
